/* eslint-disable */
import http from '@/utils/http';


const list = async ({
  id,
  attempt,
  stageId,
  uid,
}) => http.apiGet(`/scormNoAuth/${uid}/${stageId}/${id}/${attempt}`);

const recordShare = async ({
  id,
  attempt,
  stageId,
  uid,
  new_attempt
}) => http.apiGet(`/recordShareNoAuth/${uid}/${stageId}/${id}/${new_attempt}/1`);

export default {
  list,
  recordShare
};
